import { useT } from '~/i18n';
import { PLAN_PRICE, type PlanState } from './plan';

/**
 * UN solo lugar decide el texto de todo botón que lleva al plan. El caso lo
 * decide el servidor (`cta_case`); ninguna superficie lo infiere por su cuenta.
 */
export type PlanCtaCase = 'trial' | 'reactivate' | 'activate';

/** Dónde está el botón; viaja al checkout como `cta_surface`. */
export type PlanCtaSurface =
  | 'nudge'
  | 'paywall'
  | 'dashboard_expired'
  | 'dashboard_early'
  | 'plan_page'
  | 'manual_sheet'
  | 'missed_week'
  | 'jobs_for_you';

export function planCtaCase(plan: PlanState): PlanCtaCase {
  if (plan.cta_case) return plan.cta_case;
  // Servidor viejo: la misma regla que tenía el aviso.
  if (plan.trial_eligible) return 'trial';
  if (plan.plan) return 'reactivate';
  return 'activate';
}

export function usePlanCta(plan: PlanState): { case: PlanCtaCase; label: string; note: string } {
  return usePlanCtaCopy(planCtaCase(plan));
}

/** Lo mismo cuando ya se tiene el caso (la oferta lo recibe por prop). */
export function usePlanCtaCopy(ctaCase: PlanCtaCase): { case: PlanCtaCase; label: string; note: string } {
  const t = useT('plan').cta;
  const copy = t[ctaCase];
  return {
    case: ctaCase,
    label: copy.label,
    note: typeof copy.note === 'function' ? copy.note(PLAN_PRICE) : copy.note,
  };
}
